// extracted by mini-css-extract-plugin
module.exports = {"tab":"a10a3f92e9--tab--2DU3S","icon":"a10a3f92e9--icon--2UwVz"};